export default __webpack_public_path__ + "static/media/bg-pattern.bb90ab8e.png";